// import { useEffect } from 'react';
//
// const launchEmojiBurst = (count = 5) => {
//   const emojis = ['🎉', '🎊', '✨', '🥳', '🌟'];
//
//   for (let i = 0; i < count; i++) {
//     const emoji = document.createElement('div');
//     emoji.className = 'floating-emoji';
//     emoji.innerText = emojis[Math.floor(Math.random() * emojis.length)];
//
//     emoji.style.position = 'fixed';
//     emoji.style.bottom = '-40px';
//     emoji.style.left = `${Math.random() * 100}%`;
//     emoji.style.animationDuration = `${2 + Math.random() * 3}s`;
//     emoji.style.fontSize = `${24 + Math.random() * 20}px`;
//
//     document.body.appendChild(emoji);
//
//     setTimeout(() => {
//       emoji.remove();
//     }, 2000);
//   }
// };
//
// const EmojiBurstEffect = () => {
//   useEffect(() => {
//     const interval = setInterval(() => {
//       launchEmojiBurst(4); // Instead of 1,
//     }, 800); // Every 0.8 seconds
//
//     return () => clearInterval(interval);
//   }, []);
//
//   return null; // no JSX needed
// };
//
// export default EmojiBurstEffect;

import { useEffect } from 'react';

import confetti from 'canvas-confetti';

const EmojiBurstEffect = () => {
  useEffect(() => {
    const duration = 5000;
    const animationEnd = Date.now() + duration;

    const shoot = () => {
      // Center explosion
      confetti({
        particleCount: 100,
        spread: 70,
        startVelocity: 50,
        origin: { x: 0.5, y: 0.4 },
        zIndex: 9999,
        colors: ['#ff6a00', '#ff3c00', '#fcd34d', '#a855f7', '#38bdf8'],
      });

      // Side sprays
      confetti({
        particleCount: 50,
        angle: 60,
        spread: 45,
        startVelocity: 40,
        origin: { x: 0, y: 0.7 },
        zIndex: 9999,
      });

      confetti({
        particleCount: 50,
        angle: 120,
        spread: 45,
        startVelocity: 40,
        origin: { x: 1, y: 0.7 },
        zIndex: 9999,
      });
    };

    const interval = setInterval(() => {
      if (Date.now() > animationEnd) {
        clearInterval(interval);
      } else {
        shoot();
      }
    }, 600);
  }, []);

  return null;
};

export default EmojiBurstEffect;
